
import React, { useState } from 'react'
import TextFieldPaper from '../../ui/TextFieldPaper'
import { Search } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'
import styles from './DiscoverModal.module.scss'

const DiscoverSearch = ({data, updatefilteredData}) => {
    const [ value, setValue ] = useState('')

    const filterCards = (e) => {
        const targetValue = e.target.value
        setValue(targetValue)
        const filtred = data.filter(option => ['datasetName', 'columnName'].find(key => option.dataset[key].toUpperCase().includes(targetValue.toUpperCase())))
        updatefilteredData(filtred)
    } 
    const textProps = {
        InputProps:{
            startAdornment:<InputAdornment position="start" classes={{root: styles['svg']}}><Search/></InputAdornment>,
        },
        paperProps:{
            classes:{root: styles['text-field-filter']},
        }
    }

    return ( <TextFieldPaper 
        placeholder="Search data sets & columns"
        variant="outlined"
        size='small'
        value={value}
        onChange={filterCards}
        fullWidth
        {...textProps}
    />)
}

export default DiscoverSearch